import { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import ActionIcon from '../assets/icons/Actions.png';
import Delete from '../../preStartChecks/assets/icons/Delete.svg';
import Edit from '../../preStartChecks/assets/icons/edit.svg';

const CustomToggle = forwardRef(({ onClick }, ref) => (
  <img
    className="image-click"
    alt="action button"
    src={ActionIcon}
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  />
));

export const dropdownOptions = {
  view: 'view',
  edit: 'edit',
  changestatus: 'changeStatus',
  delete: 'delete',
  newPin: 'newPin',
  resendInvite: 'resendInvite',
};

export const SignatureActionDropdown = ({
  selectedSign,
  handleDropdownOptions,
}) => {
  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} />
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() =>
            handleDropdownOptions(dropdownOptions.edit, selectedSign)
          }
        >
          <div className="d-flex">
            <img src={Edit} className="me-2" />
            <span className="dropdown-text">Edit</span>
          </div>
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            handleDropdownOptions(dropdownOptions.delete, selectedSign);
          }}
        >
          <div className="d-flex">
            <img src={Delete} className="me-2" />
            <span className="dropdown-text">Delete</span>
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
